// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_a5eb2e48",
      load: () => import("#nuxt-i18n/a5eb2e48" /* webpackChunkName: "locale_en_46json_a5eb2e48" */),
      cache: true
    },
    {
      key: "locale_en_46json_eaa12b2e",
      load: () => import("#nuxt-i18n/eaa12b2e" /* webpackChunkName: "locale_en_46json_eaa12b2e" */),
      cache: true
    },
    {
      key: "locale_en_46json_06920cea",
      load: () => import("#nuxt-i18n/06920cea" /* webpackChunkName: "locale_en_46json_06920cea" */),
      cache: true
    },
    {
      key: "locale_en_46json_42a109b0",
      load: () => import("#nuxt-i18n/42a109b0" /* webpackChunkName: "locale_en_46json_42a109b0" */),
      cache: true
    },
    {
      key: "locale_en_46json_18cdc699",
      load: () => import("#nuxt-i18n/18cdc699" /* webpackChunkName: "locale_en_46json_18cdc699" */),
      cache: true
    },
    {
      key: "locale_en_46json_7a513b1b",
      load: () => import("#nuxt-i18n/7a513b1b" /* webpackChunkName: "locale_en_46json_7a513b1b" */),
      cache: true
    },
    {
      key: "locale_en_46json_3ac0db95",
      load: () => import("#nuxt-i18n/3ac0db95" /* webpackChunkName: "locale_en_46json_3ac0db95" */),
      cache: true
    },
    {
      key: "locale_en_46json_fe183830",
      load: () => import("#nuxt-i18n/fe183830" /* webpackChunkName: "locale_en_46json_fe183830" */),
      cache: true
    },
    {
      key: "locale_en_46json_ae753b26",
      load: () => import("#nuxt-i18n/ae753b26" /* webpackChunkName: "locale_en_46json_ae753b26" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2fafdc55",
      load: () => import("#nuxt-i18n/2fafdc55" /* webpackChunkName: "locale_fr_46json_2fafdc55" */),
      cache: true
    },
    {
      key: "locale_fr_46json_316a04ee",
      load: () => import("#nuxt-i18n/316a04ee" /* webpackChunkName: "locale_fr_46json_316a04ee" */),
      cache: true
    },
    {
      key: "locale_fr_46json_eac2f3fd",
      load: () => import("#nuxt-i18n/eac2f3fd" /* webpackChunkName: "locale_fr_46json_eac2f3fd" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f925a476",
      load: () => import("#nuxt-i18n/f925a476" /* webpackChunkName: "locale_fr_46json_f925a476" */),
      cache: true
    },
    {
      key: "locale_fr_46json_19fa9e97",
      load: () => import("#nuxt-i18n/19fa9e97" /* webpackChunkName: "locale_fr_46json_19fa9e97" */),
      cache: true
    },
    {
      key: "locale_fr_46json_d99179ce",
      load: () => import("#nuxt-i18n/d99179ce" /* webpackChunkName: "locale_fr_46json_d99179ce" */),
      cache: true
    },
    {
      key: "locale_fr_46json_cb217eb1",
      load: () => import("#nuxt-i18n/cb217eb1" /* webpackChunkName: "locale_fr_46json_cb217eb1" */),
      cache: true
    },
    {
      key: "locale_fr_46json_2ad75cf9",
      load: () => import("#nuxt-i18n/2ad75cf9" /* webpackChunkName: "locale_fr_46json_2ad75cf9" */),
      cache: true
    },
    {
      key: "locale_fr_46json_72c2c910",
      load: () => import("#nuxt-i18n/72c2c910" /* webpackChunkName: "locale_fr_46json_72c2c910" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_2e654ff7",
      load: () => import("#nuxt-i18n/2e654ff7" /* webpackChunkName: "locale_nl_46json_2e654ff7" */),
      cache: true
    },
    {
      key: "locale_nl_46json_733ff0d8",
      load: () => import("#nuxt-i18n/733ff0d8" /* webpackChunkName: "locale_nl_46json_733ff0d8" */),
      cache: true
    },
    {
      key: "locale_nl_46json_0e2c648e",
      load: () => import("#nuxt-i18n/0e2c648e" /* webpackChunkName: "locale_nl_46json_0e2c648e" */),
      cache: true
    },
    {
      key: "locale_nl_46json_7f46b0a7",
      load: () => import("#nuxt-i18n/7f46b0a7" /* webpackChunkName: "locale_nl_46json_7f46b0a7" */),
      cache: true
    },
    {
      key: "locale_nl_46json_0b3a5545",
      load: () => import("#nuxt-i18n/0b3a5545" /* webpackChunkName: "locale_nl_46json_0b3a5545" */),
      cache: true
    },
    {
      key: "locale_nl_46json_1f5174b3",
      load: () => import("#nuxt-i18n/1f5174b3" /* webpackChunkName: "locale_nl_46json_1f5174b3" */),
      cache: true
    },
    {
      key: "locale_nl_46json_3f40ee22",
      load: () => import("#nuxt-i18n/3f40ee22" /* webpackChunkName: "locale_nl_46json_3f40ee22" */),
      cache: true
    },
    {
      key: "locale_nl_46json_e5b45ff8",
      load: () => import("#nuxt-i18n/e5b45ff8" /* webpackChunkName: "locale_nl_46json_e5b45ff8" */),
      cache: true
    },
    {
      key: "locale_nl_46json_754047d6",
      load: () => import("#nuxt-i18n/754047d6" /* webpackChunkName: "locale_nl_46json_754047d6" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_a2cc09d6",
      load: () => import("#nuxt-i18n/a2cc09d6" /* webpackChunkName: "locale_de_46json_a2cc09d6" */),
      cache: true
    },
    {
      key: "locale_de_46json_4f35aee2",
      load: () => import("#nuxt-i18n/4f35aee2" /* webpackChunkName: "locale_de_46json_4f35aee2" */),
      cache: true
    },
    {
      key: "locale_de_46json_b3bfe70b",
      load: () => import("#nuxt-i18n/b3bfe70b" /* webpackChunkName: "locale_de_46json_b3bfe70b" */),
      cache: true
    },
    {
      key: "locale_de_46json_adda2564",
      load: () => import("#nuxt-i18n/adda2564" /* webpackChunkName: "locale_de_46json_adda2564" */),
      cache: true
    },
    {
      key: "locale_de_46json_7a5ed64e",
      load: () => import("#nuxt-i18n/7a5ed64e" /* webpackChunkName: "locale_de_46json_7a5ed64e" */),
      cache: true
    },
    {
      key: "locale_de_46json_1ec36949",
      load: () => import("#nuxt-i18n/1ec36949" /* webpackChunkName: "locale_de_46json_1ec36949" */),
      cache: true
    },
    {
      key: "locale_de_46json_f6773526",
      load: () => import("#nuxt-i18n/f6773526" /* webpackChunkName: "locale_de_46json_f6773526" */),
      cache: true
    },
    {
      key: "locale_de_46json_6fec14f1",
      load: () => import("#nuxt-i18n/6fec14f1" /* webpackChunkName: "locale_de_46json_6fec14f1" */),
      cache: true
    },
    {
      key: "locale_de_46json_947abf87",
      load: () => import("#nuxt-i18n/947abf87" /* webpackChunkName: "locale_de_46json_947abf87" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_c8a9d9c6",
      load: () => import("#nuxt-i18n/c8a9d9c6" /* webpackChunkName: "locale_es_46json_c8a9d9c6" */),
      cache: true
    },
    {
      key: "locale_es_46json_fc71e85a",
      load: () => import("#nuxt-i18n/fc71e85a" /* webpackChunkName: "locale_es_46json_fc71e85a" */),
      cache: true
    },
    {
      key: "locale_es_46json_b945340d",
      load: () => import("#nuxt-i18n/b945340d" /* webpackChunkName: "locale_es_46json_b945340d" */),
      cache: true
    },
    {
      key: "locale_es_46json_516986ad",
      load: () => import("#nuxt-i18n/516986ad" /* webpackChunkName: "locale_es_46json_516986ad" */),
      cache: true
    },
    {
      key: "locale_es_46json_653475e4",
      load: () => import("#nuxt-i18n/653475e4" /* webpackChunkName: "locale_es_46json_653475e4" */),
      cache: true
    },
    {
      key: "locale_es_46json_71840512",
      load: () => import("#nuxt-i18n/71840512" /* webpackChunkName: "locale_es_46json_71840512" */),
      cache: true
    },
    {
      key: "locale_es_46json_014fca79",
      load: () => import("#nuxt-i18n/014fca79" /* webpackChunkName: "locale_es_46json_014fca79" */),
      cache: true
    },
    {
      key: "locale_es_46json_be359e46",
      load: () => import("#nuxt-i18n/be359e46" /* webpackChunkName: "locale_es_46json_be359e46" */),
      cache: true
    },
    {
      key: "locale_es_46json_9742b4f1",
      load: () => import("#nuxt-i18n/9742b4f1" /* webpackChunkName: "locale_es_46json_9742b4f1" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8ba2f48e",
      load: () => import("#nuxt-i18n/8ba2f48e" /* webpackChunkName: "locale_it_46json_8ba2f48e" */),
      cache: true
    },
    {
      key: "locale_it_46json_7d73cd91",
      load: () => import("#nuxt-i18n/7d73cd91" /* webpackChunkName: "locale_it_46json_7d73cd91" */),
      cache: true
    },
    {
      key: "locale_it_46json_3c3c3bda",
      load: () => import("#nuxt-i18n/3c3c3bda" /* webpackChunkName: "locale_it_46json_3c3c3bda" */),
      cache: true
    },
    {
      key: "locale_it_46json_83519cc9",
      load: () => import("#nuxt-i18n/83519cc9" /* webpackChunkName: "locale_it_46json_83519cc9" */),
      cache: true
    },
    {
      key: "locale_it_46json_1def25ba",
      load: () => import("#nuxt-i18n/1def25ba" /* webpackChunkName: "locale_it_46json_1def25ba" */),
      cache: true
    },
    {
      key: "locale_it_46json_591652e7",
      load: () => import("#nuxt-i18n/591652e7" /* webpackChunkName: "locale_it_46json_591652e7" */),
      cache: true
    },
    {
      key: "locale_it_46json_3f1beb05",
      load: () => import("#nuxt-i18n/3f1beb05" /* webpackChunkName: "locale_it_46json_3f1beb05" */),
      cache: true
    },
    {
      key: "locale_it_46json_af062d65",
      load: () => import("#nuxt-i18n/af062d65" /* webpackChunkName: "locale_it_46json_af062d65" */),
      cache: true
    },
    {
      key: "locale_it_46json_95e6b530",
      load: () => import("#nuxt-i18n/95e6b530" /* webpackChunkName: "locale_it_46json_95e6b530" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_08b00394",
      load: () => import("#nuxt-i18n/08b00394" /* webpackChunkName: "locale_pl_46json_08b00394" */),
      cache: true
    },
    {
      key: "locale_pl_46json_1455304b",
      load: () => import("#nuxt-i18n/1455304b" /* webpackChunkName: "locale_pl_46json_1455304b" */),
      cache: true
    },
    {
      key: "locale_pl_46json_209a0bce",
      load: () => import("#nuxt-i18n/209a0bce" /* webpackChunkName: "locale_pl_46json_209a0bce" */),
      cache: true
    },
    {
      key: "locale_pl_46json_f66c9c16",
      load: () => import("#nuxt-i18n/f66c9c16" /* webpackChunkName: "locale_pl_46json_f66c9c16" */),
      cache: true
    },
    {
      key: "locale_pl_46json_9592fbc2",
      load: () => import("#nuxt-i18n/9592fbc2" /* webpackChunkName: "locale_pl_46json_9592fbc2" */),
      cache: true
    },
    {
      key: "locale_pl_46json_3fbbf5d2",
      load: () => import("#nuxt-i18n/3fbbf5d2" /* webpackChunkName: "locale_pl_46json_3fbbf5d2" */),
      cache: true
    },
    {
      key: "locale_pl_46json_e10a9d90",
      load: () => import("#nuxt-i18n/e10a9d90" /* webpackChunkName: "locale_pl_46json_e10a9d90" */),
      cache: true
    },
    {
      key: "locale_pl_46json_dcd40094",
      load: () => import("#nuxt-i18n/dcd40094" /* webpackChunkName: "locale_pl_46json_dcd40094" */),
      cache: true
    },
    {
      key: "locale_pl_46json_2d22059d",
      load: () => import("#nuxt-i18n/2d22059d" /* webpackChunkName: "locale_pl_46json_2d22059d" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_947e364c",
      load: () => import("#nuxt-i18n/947e364c" /* webpackChunkName: "locale_ko_46json_947e364c" */),
      cache: true
    },
    {
      key: "locale_ko_46json_dd5344a7",
      load: () => import("#nuxt-i18n/dd5344a7" /* webpackChunkName: "locale_ko_46json_dd5344a7" */),
      cache: true
    },
    {
      key: "locale_ko_46json_a1628713",
      load: () => import("#nuxt-i18n/a1628713" /* webpackChunkName: "locale_ko_46json_a1628713" */),
      cache: true
    },
    {
      key: "locale_ko_46json_ae68ffe7",
      load: () => import("#nuxt-i18n/ae68ffe7" /* webpackChunkName: "locale_ko_46json_ae68ffe7" */),
      cache: true
    },
    {
      key: "locale_ko_46json_0ed45b9b",
      load: () => import("#nuxt-i18n/0ed45b9b" /* webpackChunkName: "locale_ko_46json_0ed45b9b" */),
      cache: true
    },
    {
      key: "locale_ko_46json_f1f3dcc7",
      load: () => import("#nuxt-i18n/f1f3dcc7" /* webpackChunkName: "locale_ko_46json_f1f3dcc7" */),
      cache: true
    },
    {
      key: "locale_ko_46json_5eded83f",
      load: () => import("#nuxt-i18n/5eded83f" /* webpackChunkName: "locale_ko_46json_5eded83f" */),
      cache: true
    },
    {
      key: "locale_ko_46json_d83d8bc6",
      load: () => import("#nuxt-i18n/d83d8bc6" /* webpackChunkName: "locale_ko_46json_d83d8bc6" */),
      cache: true
    },
    {
      key: "locale_ko_46json_c2342af9",
      load: () => import("#nuxt-i18n/c2342af9" /* webpackChunkName: "locale_ko_46json_c2342af9" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_ba566293",
      load: () => import("#nuxt-i18n/ba566293" /* webpackChunkName: "locale_uk_46json_ba566293" */),
      cache: true
    },
    {
      key: "locale_uk_46json_bb69be7a",
      load: () => import("#nuxt-i18n/bb69be7a" /* webpackChunkName: "locale_uk_46json_bb69be7a" */),
      cache: true
    },
    {
      key: "locale_uk_46json_bbac625c",
      load: () => import("#nuxt-i18n/bbac625c" /* webpackChunkName: "locale_uk_46json_bbac625c" */),
      cache: true
    },
    {
      key: "locale_uk_46json_b56f5fb6",
      load: () => import("#nuxt-i18n/b56f5fb6" /* webpackChunkName: "locale_uk_46json_b56f5fb6" */),
      cache: true
    },
    {
      key: "locale_uk_46json_81a80d67",
      load: () => import("#nuxt-i18n/81a80d67" /* webpackChunkName: "locale_uk_46json_81a80d67" */),
      cache: true
    },
    {
      key: "locale_uk_46json_8359a86c",
      load: () => import("#nuxt-i18n/8359a86c" /* webpackChunkName: "locale_uk_46json_8359a86c" */),
      cache: true
    },
    {
      key: "locale_uk_46json_0c5535af",
      load: () => import("#nuxt-i18n/0c5535af" /* webpackChunkName: "locale_uk_46json_0c5535af" */),
      cache: true
    },
    {
      key: "locale_uk_46json_e9e84b27",
      load: () => import("#nuxt-i18n/e9e84b27" /* webpackChunkName: "locale_uk_46json_e9e84b27" */),
      cache: true
    },
    {
      key: "locale_uk_46json_f522e02d",
      load: () => import("#nuxt-i18n/f522e02d" /* webpackChunkName: "locale_uk_46json_f522e02d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  }
]

